import { formatNumber } from '@angular/common';
import { Optional, Pipe, PipeTransform } from '@angular/core';
import { NumberFormat } from '../../auth/models/mmu-user-preferences';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';


@Pipe({
  name: 'formatNumber'
})
export class MmuFormatNumberPipe implements PipeTransform {
  private readonly _numberFormat: NumberFormat;

  constructor(@Optional() private userService?: MmuUserService) {
    this._numberFormat = this.userService?.user?.prefs?.numberFormat ?? NumberFormat.PERIOD_SEPARATED;
  }

  transform(value: number, digitsInfo?: string): string;
  transform(value: null | undefined, digitsInfo?: string): null;
  transform(value: number | null | undefined, digitsInfo?: string): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    // en-US is used as the default locale by Angular and should always be available
    const formattedValue = formatNumber(value, 'en-US', digitsInfo);

    /* In 'en-US' locale, comma char is used as thousands separator and dot is used as decimal separator. We need to replace them with the
     correct separators based on the user settings. */
    return this.replaceSeparators(formattedValue);
  }

  private replaceSeparators(value: string): string {
    // Use intermediate separators to avoid conflicts: '_T_' is thousands separator, '_D_' is decimal separator
    value = value.replace(/,/g, '_T_').replace(/\./g, '_D_');

    switch (this._numberFormat) {
      case NumberFormat.PERIOD_SEPARATED:
        return value.replace(/_T_/g, '.').replace(/_D_/g, ',');
      case NumberFormat.SPACE_SEPARATED:
        return value.replace(/_T_/g, ' ').replace(/_D_/g, ',');
      case NumberFormat.COMMA_SEPARATED:
      default:
        return value.replace(/_T_/g, ',').replace(/_D_/g, '.');
    }
  }
}
